module.exports = __webpack_public_path__ + "static/Egan-Jones-ccad2a63c9002f5236eee2b96104c5b4.png";